import {
    FrontendExperimentsResponse,
    Identifiers
} from "@atlassian/feature-gate-node-client-bootstrapper";

export type FeatureGatesBootstrapValues = FrontendExperimentsResponse & {
    identifiers: Identifiers;
};

declare global {
    interface Window {
        featureGateBootstrapValues: FeatureGatesBootstrapValues;
    }
}

export enum StatsigFeatureGateKey {
    BXPSU_2854_CONFLUENCE_PUBLIC_LINK = "bxpsu-2854_confluence_public_link", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/bxpsu-2854_confluence_public_link
    JFIND_DEFAULT_PROVISIONING = "jfind-default-provisioning" // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jfind-default-provisioning
}

export enum StatsigExperimentKey {
    WAC_SIGNUP_UPGRADE_PATH = "wac_signup_upgrade_path", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/wac_signup_upgrade_path
    JFIND_COMPANY_EXPAND = "jfind-company-expand", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-company-expand
    JFIND_CONTACT_EXPAND = "jfind-contact-expand", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-contact-expand
    JFIND_SANDBOX_M1_5 = "jfind-sandbox-m1-5", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-sandbox-m1-5
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS = "jfind-transparent-template-for-all-teams", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-transparent-template-for-all-teams
    JFIND_ANIMATED_PROVISIONING_BRAND_REFRESH = "jfind-animated-provisioning-brand-refresh", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-animated-provisioning-brand-refresh
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT = "jfind-get-users-back-to-product-for-paid", // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-get-users-back-to-product-for-paid/setup
    JFIND_REDIRECT_TO_PRODUCT = "jfind-redirect-jira-users-to-product", //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-redirect-jira-users-to-product/setup
    JFIND_MOVE_PROJECT_NAMING_SCREEN = "jfind-move-proj-naming-screen", //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-move-proj-naming-screen
    JFIND_JTBD = "jfind-jtbd" //https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jfind-jtbd/setup
}

// Recommend to prefix cohort names with experiment ticket (ex. expcen-1234_variation-1)
export enum StatsigExperimentCohort {
    CONTROL = "control",
    UNEXPECTED_FAILURE = "unexpected_failure",
    NOT_ENROLLED = "not_enrolled",
    WAC_SIGNUP_UPGRADE_PATH_TEST = "test",
    JFIND_CONTACT_EXPAND_VARIANT = "jfind-contact-expand",
    JFIND_COMPANY_EXPAND_VARIANT = "jfind-company-expand",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_CONTROL = "control",
    JFIND_TRANSPARENT_TEMPLATE_FOR_ALL_TEAMS_VARIANT = "variant",
    JFIND_REDIRECT_TO_PRODUCT_CONTROL = "control",
    JFIND_REDIRECT_TO_PRODUCT_VARIANT = "variant",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_CONTROL = "control",
    JFIND_PAID_GET_USERS_BACK_TO_PRODUCT_VARIANT = "variation",
    JFIND_MOVE_PROJECT_NAMING_SCREEN_CONTROL = "control",
    JFIND_MOVE_PROJECT_NAMING_SCREEN_VARIANT = "variant",
    JFIND_JTBD_CONTROL = "control",
    JFIND_JTBD_VARIANT = "variant"
}
